<template>
    <div class="section">
            
        <div class="columns is-centered">
            <div class="column is-two-thirds">
                <form id="mpForm">
                <div class="columns is-multiline is-centered">
                    <div class="column is-two-thirds">
                        
                        <b-field label="Numero de tarjeta" label-position="on-border">
                            <b-input
                            v-model="card.cardNumber"
                            maxlength="16"
                            @input="findPaymentMethod"
                            id="cardNumber" 
                            data-checkout="cardNumber" 
                            >
                            </b-input>
                            <p  class="control">
                                <span class="button is-static"> 
                                    <img v-if="cardCompany.thumbnail" :src="cardCompany.thumbnail" class="m-t-5" alt="tarjeta-thumbnail"> 
                                    <b-icon v-else icon="credit-card"></b-icon>
                                </span>
                                
                            </p>
                        </b-field>
                        
                    </div>

                    <div class="column is-one-third" style="margin-bottom:0;">
                        
                        <b-field
                        label="CVC"
                        label-position="on-border"
                        message="Codigo de tres digitos detras de la tarjeta"
                        style="margin-bottom:0;">
                            <b-input
                            maxlength="4"
                            v-model="card.securityCode"
                            id="securityCode" 
                            data-checkout="securityCode" 
                            onselectstart="return false" 
                            onpaste="return false" 
                            onCopy="return false" 
                            onCut="return false" 
                            onDrag="return false" 
                            onDrop="return false" 
                            autocomplete=off>
                            </b-input>              
                        </b-field>
                            
                    </div>

                    <div class="column is-full">
                        <b-field label="Nombre y apellido" label-position="on-border">
                            <b-input
                            v-model="card.cardholderName"
                            id="cardholderName" 
                            data-checkout="cardholderName">
                            </b-input>
                        </b-field>
                    </div>

                    <div class="column is-half">
                        <b-field label="Fecha de vencimiento" label-position="on-border">
                            <b-input
                            v-model="card.cardExpirationMonth"
                            maxlength="2"
                            id="cardExpirationMonth"
                            class="m-l-5"
                            placeholder="06"
                            data-checkout="cardExpirationMonth" 
                            onselectstart="return false" 
                            onpaste="return false" 
                            onCopy="return false" 
                            onCut="return false" 
                            onDrag="return false" 
                            onDrop="return false" 
                            autocomplete=of>
                            </b-input>
                            <b-input
                            v-model="card.cardExpirationYear"
                            maxlength="4"
                            max="12"
                            placeholder="2024"
                            id="cardExpirationYear" 
                            data-checkout="cardExpirationYear" 
                            onselectstart="return false" 
                            onpaste="return false" 
                            onCopy="return false" 
                            onCut="return false" 
                            onDrag="return false" 
                            onDrop="return false" 
                            autocomplete=off>
                            </b-input>
                        </b-field>
                    </div>

                    <div class="column is-half">
                        <b-field label="Documento" label-position="on-border">
                            <b-select
                            v-model="card.docType"
                            id="docType" data-checkout="docType">
                            </b-select>
                            <b-input
                            v-model="card.docNumber"
                            id="docNumber" 
                            data-checkout="docNumber">
                            </b-input>
                        </b-field>
                    </div>
                    
                    <div class="column is-full">
                        <b-field label="Cuotas" label-position="on-border">
                            <b-select
                            expanded
                            id="installments"
                            v-model="card.mpInstallments">
                                <option id="defaultInstallment" value="1">1 cuota de ${{amountUy}} (${{amountUy}})</option>
                            </b-select>
                        </b-field>
                    </div>

                    <div class="column is-full has-text-centered">
                        <b-button
                        rounded
                        size="is-large"
                        expanded
                        class="is-custom"
                        @click="mpCreateToken">
                            Pagar <b-icon class="m-l-5" icon="credit-card" size="is-small"></b-icon>
                        </b-button>
                    </div>

                </div>
                </form>
            </div>
        </div>

    </div>   
</template>

<script>
import { getHandler } from '../../../../services/http'
export default {
    props:{
        mpPubKey:{
            type:String,
            default:""
        },
        method:{
            type:String,
            default:""
        },
        amountUy:{
            type:Number,
            default:""
        }
    },
    data(){
        return{
            ids:[],
            cardNumber:"",
            cardCompany:{},
            card:{
                cardNumber:"",
                securityCode:"",
                mpInstallments:1,
                cardExpirationMonth: "",
                cardExpirationYear: "",
                cardholderName: "",
                docType: "",
                docNumber: "",
            }
        }
    },
    methods:{
        findPaymentMethod(){
            if (this.card.cardNumber.length >= 6) {
                let bin = this.card.cardNumber.substring(0,6);
                window.Mercadopago.getPaymentMethod({
                    "bin": bin
                }, this.setPaymentMethod);
            } else {
                this.cardCompany={}
            }
        },
        setPaymentMethod(status, response){
            if(status <= 201){
                this.cardCompany = response[0]
                this.getInstallments()
            }
        },
        getIssuers(paymentMethodId){
            window.Mercadopago.getIssuers(
                paymentMethodId,
                this.setIssuers
            );
        },
        setIssuers(status, response){
            if (status==200){
                this.issuerId = response
            }
        },
        getInstallments(){
            window.Mercadopago.getInstallments({
                "bin": this.card.cardNumber.substring(0,6),
                "amount": parseFloat(parseFloat(this.amountUy).toFixed(2))
            }, this.setInstallments)
        },
        setInstallments(status, response){
            var defaultOption = document.getElementById("defaultInstallment")
            if (status==200){
                if (defaultOption){
                    document.getElementById("defaultInstallment").remove()
                }
                document.getElementById('installments').options.length = 0;
                response[0].payer_costs.forEach( payerCost => {
                    let opt = document.createElement('option');
                    opt.text = payerCost.recommended_message;
                    opt.value = payerCost.installments;
                    document.getElementById('installments').appendChild(opt);
                })
            }
            else if (!defaultOption){
                let opt = document.createElement('option');
                opt.text = `1 cuota de $ {{${this.amountUy}}} ($ {{${this.amountUy}}})`
                opt.value = 1;
                document.getElementById('installments').appendChild(opt);
            }

        },
        mpCreateToken(){
            window.Mercadopago.clearSession()
            window.Mercadopago.setPublishableKey(this.mpPubKey)
            window.Mercadopago.createToken(this.card, this.createPayment)
        },
        createPayment(status, response){

            if(status == 201 || status == 200){
                var token = response.id
                this.$emit("cardProcessed", {token:token, cardCompanyId:this.cardCompany.id, mpInstallments:this.card.mpInstallments})
                
                
            } else{
                
                this.$buefy.notification.open({
                    duration: 5000,
                    message: `Verifica los datos de la tarjeta`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
            }
        }
    },
    watch:{
        amountUy: function(val){
            this.setInstallments()
        },
        method: function(val){
            if(val=='mp'){
                window.Mercadopago.setPublishableKey(this.mpPubKey)
                window.Mercadopago.getIdentificationTypes();
            }
        }
    },
    mounted(){
        window.Mercadopago.setPublishableKey(this.mpPubKey)
        window.Mercadopago.getIdentificationTypes();
    }
}
</script>

<style lang="scss" scoped>
.is-custom{
    background:var(--primary);
    color:var(--text-color);
}
</style>